import React, { memo } from 'react';
import PropTypes from 'prop-types';

const AsyncIcon = ({ size = 20, color = '#14803C' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="async-icon"
    >
      <path
        d="M41.5 43.625H47.5V48.625H32.5V33.625H37.5V40.45C42.075 36.775 45 31.175 45 24.875C45 14.7 37.35 6.275 27.5 5.05V0C40.125 1.25 50 11.9 50 24.875C50 32.35 46.7 39.05 41.5 43.625ZM5 24.875C5 18.575 7.925 12.95 12.5 9.3V16.125H17.5V1.125H2.5V6.125H8.5C3.3 10.7 0 17.4 0 24.875C0 37.85 9.875 48.5 22.5 49.75V44.7C12.65 43.475 5 35.05 5 24.875ZM35.6 15.15L21.45 29.3L14.375 22.225L10.85 25.75L21.45 36.35L39.125 18.675L35.6 15.15Z"
        fill={color}
      />
    </svg>
  );
};

AsyncIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};

export default memo(AsyncIcon);
